import React, { useState } from 'react';
import Header from './components/Header';
import CreateArea from './components/CreateArea';
import Note from './components/Note';
import Count from './components/Count';
import Footer from './components/Footer';

function App() {
  const [notes, setNotes] = useState([]);

  function addNote(newNote) {
    setNotes(prevNotes => [...prevNotes, newNote]);
  }

  function deleteNote(id) {
    setNotes(prevNotes => prevNotes.filter((_, index) => index !== id));
  }

  function handleDragStart(e, index) {
    e.dataTransfer.setData("noteIndex", index);
  }

  function handleDragOver(e) {
    e.preventDefault();
  }

  function handleDrop(e, index) {
    const draggedIndex = e.dataTransfer.getData("noteIndex");
    if (draggedIndex === index) return;

    const updatedNotes = [...notes];
    const draggedNote = updatedNotes.splice(draggedIndex, 1)[0];
    updatedNotes.splice(index, 0, draggedNote);
    setNotes(updatedNotes);
  }

  return (
    <div className='main'>
      <Header />
      <CreateArea onAdd={addNote} />
      <Count count={notes.length === 0 ? "Empty" : `Showing ${notes.length} Notes in Database`} /><br />

      {notes.map((note, index) => (
        <Note
          key={index}
          id={index}
          title={note.title}
          content={note.content}
          onDelete={deleteNote}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        />
      ))}

      <Footer />
    </div>
  );
}

export default App;
